import { Injectable, inject } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { patchState } from '@res/ng-repository';
import { FilterModel } from 'ag-grid-community';
import { ServicingFirestoreService } from '../../services/servicing.firestore.service';
import { ServicingActions } from './servicing.action';
import { ServicingStateModel } from './servicing.store';

@State<ServicingStateModel>({
  name: 'servicings',
  defaults: {
    servicings: [],
    isSubscribed: false,
    isLoading: false,
    sort: [],
  },
})
@Injectable()
export class ServicingState {
  private servicingsService = inject(ServicingFirestoreService);
  // private servicingState = inject(ServicingState);
  // private dbServicing = inject(OrmService).servicingCollection;
  // private authService = inject(Auth);
  // private store = inject(Store);

  @Action(ServicingActions.GetAllServicings)
  async getAllServicings(ctx: StateContext<ServicingStateModel>) {
    ctx.patchState({ isLoading: true });
    const servicings = await this.servicingsService.GetAll();
    ctx.patchState({
      servicings: servicings.map(({ data, ref }) => ({ ...data, ref })),
      isLoading: false,
    });
  }

  @Action(ServicingActions.UpdateServicing)
  async updateServicing(
    ctx: StateContext<ServicingStateModel>,
    { servicingData, ref }: ServicingActions.UpdateServicing,
  ) {
    await this.servicingsService.Update(ref, servicingData);
  }

  @Action(ServicingActions.UpdateServicingResult)
  updateServicingResult(ctx: StateContext<ServicingStateModel>, { data }: ServicingActions.UpdateServicingResult) {
    patchState<ServicingStateModel>(ctx, 'servicings', data);
  }

  @Action(ServicingActions.PaginateQueryServicing)
  async queryServicing(
    ctx: StateContext<ServicingStateModel>,
    { request, isResetAfterFilterOrSort }: ServicingActions.PaginateQueryServicing,
  ) {
    const state = ctx.getState();
    // if (request.filterModel && (request.filterModel as FilterModel)['servicingId']) {
    //   (request.filterModel as FilterModel)['servicingId']['values'] = (request.filterModel as FilterModel)[
    //     'servicingId'
    //   ].values.map(
    //     (v: string) => this.store.selectSnapshot(ServicingState.servicings).find((servicing) => servicing.companyName === v)?.ref
    //   );
    // }
    // if (servicingId) {
    //   request.filterModel = {
    //     servicingId: { filter: this.dbServicing.ref(this.dbServicing.id(servicingId)), type: 'equals' },
    //     ...request.filterModel,
    //   };
    // }

    ctx.patchState({ isLoading: true });
    const { runs, direction } = this.servicingsService.SetQuery({
      ...request,
      count: state.servicings.length,
      data: state.servicings,
    });
    if (isResetAfterFilterOrSort) {
      const trCound = state.servicings.length;
      state.servicings = [];
      state.servicings.length = trCound;
    }
    if (JSON.stringify(state.filter) !== JSON.stringify(request.filterModel)) {
      ctx.patchState({ filter: request?.filterModel });

      state.servicings = [];
      state.servicings.length = await this.servicingsService.GetBuildedCount(runs);
    }
    if (state.servicings.length !== 0) {
      runs.push(...this.servicingsService.SetLimit({ ...request, count: state.servicings.length, data: [] }));
      ctx.patchState({ sort: request?.sortModel });

      if (!runs.some((x) => x.type === 'limit')) {
        throw new Error('No limit');
      }
      const servicings = await this.servicingsService.GetBuildedData(runs);
      ctx.patchState({ filter: request?.filterModel });

      if (direction === 'asc') {
        servicings.reverse().forEach(
          ({ data, ref }, i) =>
            (state.servicings[i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      } else {
        servicings.forEach(
          ({ data, ref }, i) =>
            (state.servicings[i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      }
    }

    ctx.patchState({ isLoading: false, servicings: state.servicings });
  }

  @Action(ServicingActions.ServicingError)
  servicingsError(ctx: StateContext<ServicingStateModel>, { error }: ServicingActions.ServicingError) {
    console.error({ error });
    // await this.servicingsService.Update(id, servicingsData);
  }

  @Action(ServicingActions.DeleteServicings)
  async deletetservicings(ctx: StateContext<ServicingStateModel>, { refs }: ServicingActions.DeleteServicings) {
    await this.servicingsService.BatchDelete(refs);
  }

  @Action(ServicingActions.GetSumsCountOf)
  public async getCountOf(
    ctx: StateContext<ServicingStateModel>,
    { fields, timePeriod, filterModel }: ServicingActions.GetSumsCountOf,
  ) {
    const query = {
      filterModel: {},
      startRow: undefined,
      endRow: undefined,
      sortModel: [],
      data: [],
      count: 0,
    };
    if (timePeriod.dateFrom && timePeriod.dateTo) {
      (query.filterModel as FilterModel)['createdAt'] = {
        colId: 'createdAt',
        type: 'inRange',
        filter: timePeriod.dateFrom,
        filterTo: timePeriod.dateTo,
      };
    }
    // if (servicingId) {
    //   filterModel = { servicingId: { filter: this.dbServicing.ref(this.dbServicing.id(servicingId)), type: 'equals' }, ...filterModel };
    // }
    for (const [fieldKey, fieldFilter] of Object.entries(filterModel ?? {})) {
      (query.filterModel as FilterModel)[fieldKey] = fieldFilter;
    }
    (query.filterModel as FilterModel)['paymentResult'] = {
      colId: 'paymentResult',
      type: 'equals',
      filter: 'Successful',
    };

    // query.filterModel.paymentResult = { colId: 'paymentResult', type: 'equals', filter: 'Successful' };
    const extraQuerry = this.servicingsService.SetQuery(query);
    const querrys: { [key: string]: { sum: number; count: number } } = {};
    for (const field of fields) {
      querrys[field.sumId] = {
        sum: await this.servicingsService.QuerySumByCreationDate(field.sumId, extraQuerry.runs),
        count: await this.servicingsService.QueryCountByCreationDate(field.countId, field.countValue, extraQuerry.runs),
      };
    }
    ctx.patchState({ sums: querrys });
  }

  @Selector()
  static servicings(state: ServicingStateModel) {
    return state.servicings;
  }
  @Selector()
  static servicingsCount(state: ServicingStateModel) {
    return state.servicings.length;
  }

  @Selector()
  static sums(state: ServicingStateModel) {
    return state.sums;
  }

  @Selector()
  static sumsByParams(state: ServicingStateModel) {
    return (field: string) => state?.sums?.[field];
  }

  @Selector()
  static servicingsState(state: ServicingStateModel) {
    return state;
  }
}
